import { convertLngLatToLatLng, convertMaplibrePointToLibmapPoint, } from '../convert.js';
export class MaplibreTouchEvent {
    #rawEvent;
    constructor(rawEvent) {
        this.#rawEvent = rawEvent;
    }
    get type() {
        return this.#rawEvent.type;
    }
    get latlng() {
        return convertLngLatToLatLng(this.#rawEvent.lngLat);
    }
    get latlngs() {
        return this.#rawEvent.lngLats.map(convertLngLatToLatLng);
    }
    get point() {
        return convertMaplibrePointToLibmapPoint(this.#rawEvent.point);
    }
    get points() {
        return this.#rawEvent.points.map(convertMaplibrePointToLibmapPoint);
    }
    preventDefault() {
        this.#rawEvent.preventDefault();
    }
    static convert(callback) {
        return (e) => callback(new MaplibreTouchEvent(e));
    }
    static isType(eventType) {
        return (eventType === 'touchstart' ||
            eventType === 'touchmove' ||
            eventType === 'touchend' ||
            eventType === 'touchcancel');
    }
    static convertType(eventType) {
        return eventType;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG91Y2guanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsiZXZlbnRzL3RvdWNoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE9BQU8sRUFDTixxQkFBcUIsRUFDckIsaUNBQWlDLEdBQ2pDLE1BQU0sZUFBZSxDQUFBO0FBRXRCLE1BQU0sT0FBTyxrQkFBa0I7SUFDOUIsU0FBUyxDQUFVO0lBRW5CLFlBQVksUUFBa0I7UUFDN0IsSUFBSSxDQUFDLFNBQVMsR0FBRyxRQUFRLENBQUE7SUFDMUIsQ0FBQztJQUVELElBQUksSUFBSTtRQUNQLE9BQU8sSUFBSSxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUE7SUFDM0IsQ0FBQztJQUNELElBQUksTUFBTTtRQUNULE9BQU8scUJBQXFCLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBQTtJQUNwRCxDQUFDO0lBQ0QsSUFBSSxPQUFPO1FBQ1YsT0FBTyxJQUFJLENBQUMsU0FBUyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMscUJBQXFCLENBQUMsQ0FBQTtJQUN6RCxDQUFDO0lBQ0QsSUFBSSxLQUFLO1FBQ1IsT0FBTyxpQ0FBaUMsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBQy9ELENBQUM7SUFDRCxJQUFJLE1BQU07UUFDVCxPQUFPLElBQUksQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxpQ0FBaUMsQ0FBQyxDQUFBO0lBQ3BFLENBQUM7SUFFRCxjQUFjO1FBQ2IsSUFBSSxDQUFDLFNBQVMsQ0FBQyxjQUFjLEVBQUUsQ0FBQTtJQUNoQyxDQUFDO0lBRUQsTUFBTSxDQUFDLE9BQU8sQ0FDYixRQUF5QztRQUV6QyxPQUFPLENBQUMsQ0FBVyxFQUFFLEVBQUUsQ0FBQyxRQUFRLENBQUMsSUFBSSxrQkFBa0IsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBQzVELENBQUM7SUFFRCxNQUFNLENBQUMsTUFBTSxDQUFDLFNBQWlCO1FBQzlCLE9BQU8sQ0FDTixTQUFTLEtBQUssWUFBWTtZQUMxQixTQUFTLEtBQUssV0FBVztZQUN6QixTQUFTLEtBQUssVUFBVTtZQUN4QixTQUFTLEtBQUssYUFBYSxDQUMzQixDQUFBO0lBQ0YsQ0FBQztJQUVELE1BQU0sQ0FBQyxXQUFXLENBQUMsU0FBcUM7UUFDdkQsT0FBTyxTQUFTLENBQUE7SUFDakIsQ0FBQztDQUNEIn0=